module.exports = __webpack_public_path__ + "static/icon-512x512-8798cf085df0d3b42b37201fa578e955.png";